<div class="plan-table">
    <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th>Descripción</th>
                    <th></th>
                    <th>Freemium</th>
                    <th>Professional</th>
                    <th>Executive</th>
                </tr>
            </thead>
        </table>
        <div class="scrollable-body">
            <table>
                <tbody>
                    <tr *ngFor="let row of data" [ngClass]="{'on-demand-row': isOnDemandFeature(row.description)}">
                        <td>{{ row.description }}</td>
                        <td><img [src]="getIcon('info')" alt="Info"></td>
                        <td><img [src]="getIcon(row.freemium)" alt="Freemium"></td>
                        <td><img [src]="getIcon(row.professional)" alt="Professional"></td>
                        <td><img [src]="getIcon(row.executive)" alt="Executive"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>    
</div>